// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"353":"contact","465":"crypto-grid","574":"footer","594":"about","933":"auth"}[chunkId] || chunkId) + "." + {"353":"0ded8415","453":"76d2fff0","465":"d56bd012","574":"7bfc16c3","594":"0d0cd5eb","933":"1c320025"}[chunkId] + ".chunk.js";
};